import $ from "jquery";

//// VALIDATION \\\\
export default function checkForm(formObjs) {
  let status = true;
  for (let i = 0; i < formObjs.length; i++) {
    let formNodesName = [];
    for (let j = 0; j < formObjs[i].length; j++) {
      if (!formNodesName.includes(formObjs[i].elements.item(j).name)) {
        if (formObjs[i].elements.item(j).name !== "") {
          formNodesName.push(formObjs[i].elements.item(j).name);
        }
      }
    }
    // debugger
    for (let j = 0; j < formNodesName.length; j++) {
      let field = formObjs[i][formNodesName[j]];
      let checked = checkRequired(field);
      if (checked === false) {
        status = false;

        if (j === 0) {
          formObjs[0][j].scrollIntoView();
        }
      }

      if (field?.dataset) {
        if (field.dataset.type) {
          switch (field.dataset.type) {
            case "email":
              emailValidate(field);
              break;
            case "mobile":
              mobileValidate(field);
              break;
            case "year":
              check_value_sal(field, 1400);
              break;
            case "date":
              let temp = dateValidate(field);
              status = temp;
              break;

            default:
              console.trace(field);
              console.error("unknown input data-type attribute");
              break;
          }
        }
      }
    }
  }

  return status;
}

export function fieldError(fieldObj, errorMsg, error = true) {
  if (error) {
    $(".form-group").has(fieldObj).find(".error-msg").html(errorMsg);
    $(fieldObj).addClass("error-field");
  } else {
    $(".form-group").has(fieldObj).find(".error-msg").html("");
    $(fieldObj).removeClass("error-field");
  }
}

function checkRequired(inputObj) {
  // if radio button
  if (inputObj.toLocaleString().includes("RadioNodeList")) {
    let required = false;
    for (let i = 0; i < inputObj.length; i++) {
      if (inputObj[i].required) {
        required = true;
        break;
      }
    }
    inputObj.required = required;
  }

  if (inputObj.required && inputObj.value.trim() == "") {
    fieldError(inputObj, "مقدار این فیلد الزامیست");
    return false;
  } else {
    fieldError(inputObj, "", false);
    return true;
  }
}

function radioButtonCheckRequired(radioObj) {
  let form = $("form").has(radioObj);
  let radioNode = form[0][radioObj.name];

  for (let i = 0; i < radioNode.length; i++) {
    if (radioNode[i].checked) {
      //   fieldError(inputObj, "", false);
      return true;
    }
  }
  fieldError(radioObj, "انتخاب یکی از گزینه ها الزامیست");
  return false;
}

export function checkDuplicate(mj, field, val2, ele, old_val) {
  let HOST = localStorage.getItem("apiUrl");
  $.ajax({
    type: "POST",
    url: `${HOST}/check_duplicate/`,
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    data: "entity=" + mj + "&" + "fieldName" + "=" + field + "&value=" + val2,
    success: function (data, textStatus, xhr) {
      if (xhr.status === 409) {
        fieldError(ele, "مقدار این فیلد تکراری است!");
        ele.value = "";
      } else {
        fieldError(ele, "", false);
      }
    },
  })
    .done(() => fieldError(ele, "", false))
    .fail((response) => {
      if (response.status === 409) {
        fieldError(ele, "مقدار این فیلد تکراری است!");
        ele.value = "";
      } else {
        fieldError(ele, response.statusText);
        ele.value = "";
      }
    });
}

$(document).on("keydown", "input[pattern]", function (e) {
  var input = $(this);
  var oldVal = input.val();
  var regex = new RegExp(input.attr("pattern"), "g");

  setTimeout(function () {
    var newVal = input.val();
    if (!regex.test(newVal)) {
      input.val(oldVal);
    }
  }, 1);
});

/* function separateNum(value, input, unit = "ريال") {
    var nStr = value + "";
    nStr = nStr.replace(/\,/g, "");
    x = nStr.split(".");
    x1 = x[0];
    x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    if (input !== undefined) {
      input.value = x1 + x2;
    } else {
      return x1 + x2;
    }
  } */

export function check_value_sal(ele, salejari) {
  if ((ele.value <= 1500 && ele.value >= 1300) || (ele.value = "")) {
    //do nothing
    fieldError(ele, "", false);
  } else {
    fieldError(ele, "لطفا سال را بصورت عددی وارد نمایید");
    ele.value = salejari;
  }
}

//for numeric input
export function isNumberKey(evt) {
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;

  return true;
  //if (charCode > 31 && (((charCode < 48) && (charCode !== 46)) || charCode > 57))    ---for decimal point
}

export function dateValidate(inputObj) {
  let dateFormat =
    /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|31|([1-2][0-9])|(0[1-9]))))$/;
  let ok = dateFormat.test(inputObj.value);
  if (inputObj.value == "") {
  } else {
    if (ok) {
      fieldError(inputObj, "", false);
    } else {
      fieldError(inputObj, "فرمت تاریخ را اصلاح نمایید");
    }
    return ok;
  }
}

export function mobileValidate(inputObj) {
  let mobileFormat = /09(1[0-9]|3[1-9]|2[1-9])-?[0-9]{3}-?[0-9]{4}/;
  let ok = mobileFormat.test(inputObj.value);
  if (ok) {
    fieldError(inputObj, "", false);
  } else {
    fieldError(inputObj, "فرمت موبایل را اصلاح نمایید");
  }
  return ok;
}
// export function separate(inputObj) {

// }

export function emailValidate(inputObj) {
  let emailFormat = /[a-zA-Z0-9.-]+@[a-z-]+.[a-z]{2,3}/;
  let ok = emailFormat.test(inputObj.value);
  if (ok) {
    fieldError(inputObj, "", false);
  } else {
    fieldError(inputObj, "فرمت ایمیل را اصلاح کنید");
  }
  return ok;
}

export function persianValidate(inputObj) {
  let persianFormat = /^[\u0600-\u06FFsd]+$/;
  let ok = persianFormat.test(inputObj.value);
  if (ok) {
    fieldError(inputObj, "", false);
  } else {
    fieldError(inputObj, "کیبورد خود را به زبان فارسی تغییر دهید");
  }
  return ok;
}
